module.exports = __webpack_public_path__ + "img/white-knot.8cb902fb.svg";